import { create } from "zustand";
import { subDays } from "date-fns";

type State = {
    selected_partner: string | null;
    selected_customer: string | null;
    selected_clientcode: string;
    selected_atmid: string;
    selected_startdate: Date;
    selected_enddate: Date;
    customers_list: Customer[] | null | undefined;
};

type Actions = {
    setselected_partner: (v: string | null) => void;
    setselected_customer: (v: string | null) => void;
    setselected_clientcode: (v: string) => void;
    setselected_atmid: (v: string) => void;
    setselected_startdate: (v: Date) => void;
    setselected_enddate: (v: Date) => void;
    setcustomers_list: (v: Customer[] | null | undefined) => void;
    reset: () => void;
};

const buildInitialState = (): State => ({
    selected_partner: null,
    selected_customer: null,
    selected_clientcode: '',
    selected_atmid: '',
    selected_startdate: subDays(new Date(), 3),
    selected_enddate: new Date(),
    customers_list: undefined,
});

const useE2EFilterStore = create<State & Actions>((set) => ({
    ...buildInitialState(),

    setselected_partner: (v) => set({ selected_partner: v }),
    setselected_customer: (v) => set({ selected_customer: v }),
    setselected_clientcode: (v) => set({ selected_clientcode: v }),
    setselected_atmid: (v) => set({ selected_atmid: v }),
    setselected_startdate: (v) => set({ selected_startdate: v }),
    setselected_enddate: (v) => set({ selected_enddate: v }),
    setcustomers_list: (v) => set({ customers_list: v }),

    reset: () => set(buildInitialState()),
}));

export default useE2EFilterStore;
